import React, { useState, useEffect } from 'react';
import { Zap, Heart, Shield, Smile, Leaf } from 'lucide-react';
import { API_URL, resolveImageUrl } from '../config';
import './FeaturesSection.css';



const IconMap = {
  Zap: Zap,
  Heart: Heart,
  Shield: Shield,
  Smile: Smile,
  Leaf: Leaf
};

const defaultSettings = {
  title: "Why Choose Himalayan Nuts?",
  description: "Every single bite is packed with pure, raw power sourced from nature's lap.",
  image: "/images/makhana_bowl.jpg",
  benefits: [
    {
      icon: "Zap",
      title: "High in Protein",
      description: "Helps build muscle, repair tissues, and provides long-lasting natural energy."
    },
    {
      icon: "Leaf",
      title: "Rich in Nutrients",
      description: "Packed with essential vitamins, minerals, and antioxidants for overall body health."
    },
    {
      icon: "Heart",
      title: "Heart Friendly",
      description: "Contains zero trans fats and low sodium to keep cholesterol and blood pressure stable."
    },
    {
      icon: "Shield",
      title: "Immunity Booster",
      description: "Loaded with zinc and magnesium to naturally enhance your body's immune defense."
    },
    {
      icon: "Smile",
      title: "Healthy Snacking",
      description: "A low-calorie, high-fiber, gluten-free option that satisfies hunger wholesomely."
    }
  ]
};

const FeaturesSection = () => {
  const [settings, setSettings] = useState(defaultSettings);

  useEffect(() => {
    fetch(`${API_URL}/settings/features_section`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load features section settings');
        return res.json();
      })
      .then((data) => {
        if (data && Array.isArray(data.benefits)) {
          setSettings(data);
        }
      })
      .catch((err) => console.error('Error fetching features_section settings:', err));
  }, []);

  return (
    <section className="benefits-section" aria-label="Product Benefits">
      <div className="container">
        <div className="benefits-banner-box">
          
          {/* Left Side: Benefit Cards */}
          <div className="benefits-left">
            <div>
              <h2 className="benefits-title">{settings.title}</h2>
              <p className="benefits-description">
                {settings.description}
              </p>
            </div>
            
            <div className="benefits-list">
              {settings.benefits && settings.benefits.map((benefit, index) => {
                const IconComponent = IconMap[benefit.icon] || Leaf;
                return (
                  <div key={index} className="benefit-item">
                    <div className="benefit-icon-wrapper">
                      <IconComponent size={22} />
                    </div>
                    <div className="benefit-info-box">
                      <h3 className="benefit-item-title">{benefit.title}</h3>
                      <p className="benefit-item-desc">{benefit.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Side: Makhana Bowl & Floating Leaves */}
          <div className="benefits-right">
            {/* Floating leaf decorators */}
            <span className="floating-leaf leaf-1" aria-hidden="true">🍃</span>
            <span className="floating-leaf leaf-2" aria-hidden="true">🍂</span>
            
            <div className="benefits-right-img-container">
              <img 
                src={resolveImageUrl(settings.image)} 
                alt={settings.title} 
                loading="lazy" 
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
